import defaultStyles from "../../../styles/defaultStyles";

export default (theme) => ({
  ...defaultStyles,
  widgetIconContainer: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: "2147483647",
    width: "auto",
  },
  widgetIconBase: {
    WebkitUserSelect: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    height: "48px !important",
    width: "48px",
    borderRadius: "50%",
    opacity: "1",
    border: "0",
    fontSize: "1.1em",
    color: theme.internalWhite,
    background: `${theme.primaryColor} !important`,
    boxShadow: "0 4px 5px rgba(0, 0, 0, 0.12) !important",
    WebkitTransition: "all 150ms ease",
    MozTransition: "background-color all 150ms ease",
    OTransition: "background-color all 150ms ease",
    transition: "background-color all 150ms ease",
  },
  widgetIcon: {
    composes: "$widgetIconBase",
    background: `${theme.chatWidget} !important`,
    height: "60px !important",
    width: "60px",
    float: "right",
    animationName: "$slide-up",
    animationDuration: "0.4s",
    animationTimingFunction: "ease",
    fontSize: "20px !important",
    "&:hover": { filter: "brightness(0.9)" },
  },
  innerIcon: { display: "block", margin: "0 auto" },
  "@keyframes slide-up": {
    "0%": { opacity: "0", transform: "translateY(40px)" },
    "100%": { opacity: "1", transform: "translateY(0)" },
  },
  notificationCircle: {
    borderRadius: "50%",
    position: "absolute",
    height: "16px",
    width: "16px",
    fontSize: "12px",
    bottom: "42px",
    right: "0px",
    backgroundColor: "rgb(235, 51, 48)",
    border: "solid 3px white",
    display: "none",
    animationName: "$scale-in-center",
    animationDuration: "0.5s",
    animationTimingFunction: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    animationFillMode: "both",
  },
  innerText: {
    color: "white",
    position: "relative",
    top: "50%",
    transform: "translateY(-50%)",
  },
  unFade: { display: "unset" },
  "@keyframes scale-in-center": {
    "0%": {
      WebkitTransform: "scale(0)",
      transform: "scale(0)",
      opacity: "1",
    },
    "100%": {
      WebkitTransform: "scale(1)",
      transform: "scale(1)",
      opacity: "1",
    },
  },
});
